<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-size__large font-weight__bold">
              {{ pageTitle }}
            </div>
            <slot name="headerExtend">
            </slot>
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <slot name="filter"></slot>
              </template>
            </sub-header>
          </template>

          <template #body>
            <div class="list">
              <slot name="mainContent"></slot>
            </div>
          </template>
        </list-template>
      </div>
    </template>
  </list-template>
</template>

<script>
  import ListTemplate from "../list";
  import MainHeader from "../../../components/header/main-header";
  import SubHeader from "../../../components/main/sub-header";

  export default {
    name: "page-template",
    props: ["pageTitle"],
    components: {SubHeader, MainHeader, ListTemplate}
  };
</script>

<style scoped>
  .leftSection {
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/layout/page-template.vue